<ejs-toast #toast [position]="position" [timeOut]="0">
  <ng-template
    #title
    *ngIf="notification.title && notification.title.length > 0"
  >
    <span>{{ notification.title }}</span>
  </ng-template>
  <ng-template #content>
    <span>{{ notification.body }}</span>
    <button ejs-button class="toast-btn" (click)="onDismiss()">Dismiss</button>
  </ng-template>
</ejs-toast>
